module.exports = __webpack_public_path__ + "static/scale-410c2a160bc1fd70629c6d3d42f6833b.png";